import { Injectable } from '@angular/core';
import { AngularFirestore, AngularFirestoreCollection } from 'angularfire2/firestore';
import { AngularFireAuth } from 'angularfire2/auth';
import { AuthService } from './auth.service';
import * as firebase from 'firebase';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { NotificationService } from '@app/core/services/notification.service';

import * as moment from 'moment-timezone';

@Injectable()
export class MessagingService {

  private messaging = firebase.messaging()

  private messageSource = new Subject()
  currentMessage = this.messageSource.asObservable()

  constructor(private afs: AngularFirestore, private ns: NotificationService) {

  }

  

  // get permission to send messages
  getPermission(user) {
    this.messaging.requestPermission()
    .then(() => {
      return this.messaging.getToken()
    })
    .then(token => {
      this.saveToken(user, token)
    })
    .catch((err) => {
      console.error('Unable to get permission to notify.', err);
    });
  }


  // Listen for token refresh
  monitorRefresh(user) {
    this.messaging.onTokenRefresh(() => {
      this.messaging.getToken()
      .then(refreshedToken => {
        this.saveToken(user, refreshedToken)
      })
      .catch( err => console.error(err, 'Unable to retrieve new token') )
    });
  }

  

  // used to show message when app is open
  receiveMessages() {
    this.messaging.onMessage(payload => {
     console.log('Message received....... ', payload);
     if(payload.data){
       if(payload.data.type=='rdealer'){
          this.ns.alertNewOrder(payload, null);
       }else if(payload.data.type=='open-office'){
          this.alertOpenOffice(payload);
       }else if(payload.data.type=='rProducts'){
        this.ns.bigAlertNewOrder(payload, null);
       }else{
        this.ns.alertOK(payload.notification.body, payload.notification.title);
       }
     }else
      alert(payload.notification.body + ' ' + payload.notification.title);
     
     this.messageSource.next(payload)
   });

  }

  alertOpenOffice(message:any){
      this.ns.alertBox(
        "Apertura/Cierre de local",
        message.notification.body,
        message.data.open=='true'?"#8fb435":"#FF0000",
        moment(Number(message.data.time)).format('HH:mm DD-MMM')
      );
  }

  // save the permission token in firestore
  /*private saveToken(user, token): void {
    
      const currentTokens = user.fcmTokens || { }
      console.log(currentTokens, token)

      // If token does not exist in firestore, update db
      if (!currentTokens[token]) {
        const userRef = this.afs.collection('users').doc(user.uid)
        const tokens = { ...currentTokens, [token]: true }
        userRef.update({ fcmTokens: tokens })
      }
  }*/

  private async saveToken(user, token){
    if(!token) return;
    const devicesRef = this.afs.collection('devices');
        
    const docData = {
      token,
      userId: user.uid,
      type: 'web',
      createdAt: firebase.firestore.FieldValue.serverTimestamp(),
    }

    return devicesRef.doc(token).set(docData);
  }

}